import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  ListItem,
  ListItemAvatar,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { currencyFormat } from "../../common/components/Utils";

import { saveTrainer } from "../../../../store/cpd/actions";
import { getDistricts, getSectors } from "../../../../store/posts/actions";

import { isEmpty, truncate } from "lodash";
import axios from "axios";
import { CSVLink } from "react-csv";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
// import { showError } from "../../toastify";
import defaultPofile from "../../../assets/default-profile.jpg";
import { idNumberPattern } from "../../common/components/Utils";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const personalEmailValidator = joi.object({
  email: joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: ["com", "fr", "rw"] },
  }),
});

const genders = [
  { id: "M", name: "Male" },
  { id: "F", name: "Female" },
];

const civilStatuses = [
  { id: "S", name: "Single" },
  { id: "M", name: "Married" },
  { id: "D", name: "Divorced" },
  { id: "W", name: "Widowed" },
  { id: "R", name: "Religious" },
];

const PreviewTrainerDialog = (props) => {
  const {
    user,
    loading,
    trainer,
    showDialog,
    setShowDialog,
    saveTrainer,
    trainerCategories,
    trainingProviders,
    getDistricts,
    totalRecods,
    setTotalRecods,
    countries,
  } = props;

  const onClose = () => {
    setShowDialog(false);
  };

  const [errors, setErrors] = useState({
    nidNumberHasError: false,
    emailHasError: false,
    phoneNumberHasError: false,
    providersHasError: false,
    trainerCategoryHasError: false,
    employeeIdHasError: false,
    staffCodeHasError: false,
    hasError: false,
  });

  const teacherInfoFormValidator = () => {
    const error = {
      nidNumberHasError: false,
      emailHasError: false,
      phoneNumberHasError: false,
      providersHasError: false,
      trainerCategoryHasError: false,
      employeeIdHasError: false,
      staffCodeHasError: false,
      hasError: false,
    };

    if (
      ((teacherForm.nidNumber || "").replace(/\s/g, "").length !== 16 ||
        !!idHasError) &&
      !!disabled()
    ) {
      error.nidNumberHasError = true;
      error.hasError = true;
    }

    if (!nationality) {
      error.nationalityHasError = true;
      error.hasError = true;
    }

    if (!disabled() && !teacherForm.passportNumber) {
      error.passportNumberHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.lastName) {
      error.lastNameHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.firstName) {
      error.firstNameHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.genderId) {
      error.genderIdHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.civilStatusId) {
      error.civilStatusIdHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.dateOfBirth) {
      error.dateOfBirthHasError = true;
      error.hasError = true;
    }

    if ((teacherForm.phoneNumber || "").replace(/\s/g, "").length !== 10) {
      error.phoneNumberHasError = true;
      error.hasError = true;
    }

    if (
      !teacherForm.email ||
      (!!teacherForm.email &&
        personalEmailValidator.validate({ email: teacherForm.email }).error)
    ) {
      error.emailHasError = true;
      error.hasError = true;
    }

    if (!selectedCategories.length) {
      error.trainerCategoryHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  const [isVerifing, setIsVerifing] = useState(false);
  const [wasVerified, setWasVerified] = useState(false);
  const [idHasError, setIdHasError] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedProviders, setSelectedProviders] = useState([]);

  const [teacherForm, setTeacherForm] = useState({
    id: "",
    employeeId: "",
    nidNumber: "",
    nin: "",
    email: "",
    phoneNumber: "",
    gender: "",
    genderId: "",
    countryOfBirth: "",
    countryIdOfBirth: "",
    firstName: "",
    lastName: "",
    civilStatus: "",
    civilStatusId: "",
    spouseNames: "",
    fatherNames: "",
    motherNames: "",
    dateOfBirth: "",
    placeOfBirth: "",
    nationalityId: "",
    villageId: "",
    placementDate: null,
    profilePicture: "",

    rssbNumber: "",
    accountNumber: "",
    bankId: "",
    bankName: "",
    sdmsStaffCode: "",
  });

  useEffect(() => {
    getDistricts();
  }, []);

  const getNidDetails = async (nidNumber) => {
    try {
      let staff = {};
      try {
        const { data: tmisData } = await axios.get(
          "/api/users/search-staff/" + (nidNumber || "").replace(/\s/g, ""),
        );

        staff = tmisData;
      } catch (error) {}

      setWasVerified(false);
      setIsVerifing(true);

      const { data } = await axios.get(
        "/api/users/citizen/" + (nidNumber || "").replace(/\s/g, ""),
      );

      setTeacherForm({
        ...teacherForm,
        id: staff?.id || "",
        nidNumber: nidNumber,
        nin: data.nin,
        gender: data.gender,
        genderId: data.genderId,
        countryOfBirth: data.countryOfBirth,
        countryIdOfBirth: data.countryIdOfBirth,
        firstName: data.firstName,
        lastName: data.lastName,
        civilStatus: data.civilStatus,
        civilStatusId: data.civilStatusId,
        spouseNames: data.spouseNames,
        fatherNames: data.fatherNames,
        motherNames: data.motherNames,
        dateOfBirth: data.dateOfBirth,
        placeOfBirth: data.placeOfBirth,
        nationalityId: data.nationalityId,
        villageId: data.villageId,
        profilePicture: data.profileImage,

        employeeId: data.employee?.id || "",
        rssbNumber: data.employee?.rssbNumber || "",
        accountNumber: data.employee?.accountNumber || "",
        bankId: data.employee?.bankId || "",
        bankName: data.employee?.bankName || "",

        sdmsStaffCode: staff?.id || data.employee?.id || "",
        email: staff?.email?.trim() || "",
        phoneNumber: staff?.phoneNumber?.trim() || "",
      });

      // setChanged(true);
      setIdHasError(false);
      setWasVerified(true);
      setIsVerifing(false);
    } catch (error) {
      // setChanged(false);
      setIdHasError(true);
      setWasVerified(false);
      setIsVerifing(false);
    }
  };

  const onSave = () => {
    if (!teacherInfoFormValidator())
      saveTrainer(
        {
          id: teacherForm.id,
          employeeId: teacherForm.employeeId,
          lastName: teacherForm.lastName || null,
          firstName: teacherForm.firstName || null,
          email: teacherForm.email?.trim(),
          phoneNumber: teacherForm.phoneNumber?.trim(),
          nidNumber: teacherForm.nidNumber.replace(/\s/g, ""),
          passportNumber: teacherForm.passportNumber || null,
          nin: teacherForm.nin || null,
          gender: teacherForm.genderId || null,
          dateOfBirth: teacherForm.dateOfBirth || null,
          placeOfBirth: teacherForm.placeOfBirth || null,
          fatherNames: teacherForm.fatherNames || null,
          motherNames: teacherForm.motherNames || null,
          civilStatusId: teacherForm.civilStatusId || null,
          spouseNames: teacherForm.spouseNames || null,
          countryOfBirth: teacherForm.countryIdOfBirth || null,
          nationalityId: teacherForm.nationalityId || null,
          residenceVillageId: teacherForm.villageId || null,
          bankId: teacherForm.bankId || null,
          bankAccountNumber: teacherForm.bankAccountNumber || null,
          rssbNumber: teacherForm.rssbNumber || null,
          categories: selectedCategories.map(({ id }) => id),
        },

        () => {
          if (!teacherForm.id) setTotalRecods(totalRecods + 1);
        },
        onClose,
      );
  };

  const [nationality, setNationality] = useState(null);
  const [countryOfBirth, setCountryOfBirth] = useState(null);

  useEffect(() => {
    if (!!countries.length)
      setNationality(countries.find(({ id }) => id === "RW"));
  }, [countries]);

  const disabled = () => nationality?.id === "RW";

  const [categories, setCategories] = useState([]);

  const [providerTrainerCategories, setProviderTrainerCategories] = useState(
    [],
  );

  const getProviderTrainerCategories = async () => {
    try {
      const { data } = await axios.get(
        `/api/cpd/provider-trainer-categories/${trainer.id}`,
      );

      setProviderTrainerCategories(data);
    } catch (error) {}
  };

  useEffect(() => {
    getProviderTrainerCategories();
  }, [trainer]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
          <span className="d-flex align-items-center mb-2">
            <Typography className="d-flex align-items-center text-primary">
              <span className="text-dark mr-1">
                {!!trainer ? "Update " : "Add New "}
                {" Trainer"}
              </span>
              {!!trainer && (
                <>
                  {trainer?.lastName} {trainer?.firstName}
                </>
              )}
            </Typography>
          </span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-0">
          <div className="mt-0" style={{ height: "100%" }}>
            <div
              style={{
                display: "table-cell",
                width: "100vw",
                height: "45vh",
                padding: "10px",
                verticalAlign: "middle",
              }}
            >
              <div className="row mx-0">
                <div className="col-4 text-left">
                  <TextField
                    InputProps={{ readOnly: true }}
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="nationalityId"
                    label="Nationality"
                    placeholder="Nationality"
                    variant="outlined"
                    value={trainer.nationalityName}
                  />
                </div>

                <div className="col-8 justify-content-center">
                  {trainer.nationalityId === "RW" ? (
                    <MaskedInput
                      readOnly={true}
                      mask={idNumberPattern}
                      className="form-control "
                      placeholder="NID Number"
                      guide={false}
                      value={trainer.nidNumber}
                    />
                  ) : (
                    <TextField
                      InputProps={{ readOnly: true }}
                      fullWidth
                      size="small"
                      autoComplete="false"
                      name="passportNumber"
                      label="Passport number"
                      placeholder="Passport number"
                      variant="outlined"
                      value={trainer.passportNumber}
                    />
                  )}
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    InputProps={{ readOnly: true }}
                    fullWidth
                    size="small"
                    name="lastName"
                    label="Last Name"
                    placeholder="Last Name"
                    variant="outlined"
                    value={trainer.lastName}
                  />
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    name="firstName"
                    InputProps={{
                      readOnly: true,
                    }}
                    label="First Name"
                    placeholder="First Name"
                    variant="outlined"
                    className=""
                    value={trainer.firstName}
                  />
                </div>

                <div className="col-4 mt-3 text-left">
                  <FormControl size="small" required fullWidth>
                    <InputLabel id="genderId">Gender</InputLabel>
                    <Select
                      readOnly={true}
                      labelId="genderId"
                      id="genderId"
                      value={trainer.gender}
                      label="Gender"
                      placeholder="Gender"
                    >
                      {genders.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="col-4 mt-3 text-left">
                  <FormControl size="small" required fullWidth>
                    <InputLabel id="civilStatusId">Civil status</InputLabel>
                    <Select
                      readOnly={true}
                      labelId="civilStatusId"
                      id="civilStatusId"
                      value={trainer.civilStatusId}
                      label="Civil status"
                      placeholder="Civil status"
                    >
                      {civilStatuses.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    name="dateOfBirth"
                    value={
                      !!trainer.dateOfBirth
                        ? moment(trainer.dateOfBirth).format("DD/MM/yyyy")
                        : ""
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Date Of Birth"
                    placeholder="Date Of Birth"
                    variant="outlined"
                  />
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    name="countryOfBirth"
                    value={trainer.countryOfBirth}
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Country of Birth"
                    variant="outlined"
                    className=""
                  />
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    style={{ backgroundColor: "#e9ecef" }}
                    fullWidth
                    size="small"
                    name="staffCode"
                    value={trainer?.userId || ""}
                    label="Staff Code"
                    placeholder="Staff Code"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
                <div className="col-8 mt-3 text-left">
                  <TextField
                    style={{ backgroundColor: "#e9ecef" }}
                    fullWidth
                    size="small"
                    name="employeeId"
                    value={trainer?.employeeId || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                    label="IPPIS Employee ID"
                    variant="outlined"
                    className=""
                  />
                </div>

                <div className="col-6  mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="phone"
                    label="Phone number"
                    placeholder="Phone number"
                    variant="outlined"
                    value={trainer.phoneNumber}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
                <div className="col-6  mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="email"
                    label="Personal email"
                    placeholder="Personal email"
                    variant="outlined"
                    value={trainer.email}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>

                <div className="mt-3 col-12">
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="Provider"
                    label="Provider"
                    placeholder="Provider"
                    variant="outlined"
                    value={trainer.providerName}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>

                <div className="col-12 mt-3">
                  <table className="table table-striped ">
                    <thead>
                      <tr style={{ backgroundColor: "#f0f2f5" }}>
                        <th scope="col" colSpan={2}>
                          Trainer category
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {providerTrainerCategories.map((category, index) => (
                        <tr>
                          <td className="text-left">{index + 1}</td>
                          <td className="text-left">{category.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  onWait,
  placementReportDetails,
  changeList,
  prevPlacementReport,
  signatories,
  roles,
  districts,
  sectors,
  trainerCategories,
  trainingProviders,
  countries,
}) => {
  return {
    user,
    loading,
    onWait,
    placementReportDetails,
    changeList,
    prevPlacementReport,
    signatories,
    roles,
    districts,
    sectors,
    trainerCategories,
    trainingProviders,
    countries,
  };
};
export default connect(mapStateToProps, {
  saveTrainer,
  getSectors,
  getDistricts,
})(PreviewTrainerDialog);
